/**
 * SalesMailer
 * SalesMailer
 *
 * OpenAPI spec version: n/a
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/';

import { CreateDocument } from '../model/createDocument';
import { PrivateDocumentDetails } from '../model/privateDocumentDetails';
import { PrivateDocumentList } from '../model/privateDocumentList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MyLibraryService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Dodawanie dokumentu przez Handlowca
     *  - __InputModelName__: CreateDocument - __InputParser__: serializer - __OperationName__: Handler - __OperationId__: CreateMyDocumentHandler - __Name__:  - __Path__: /my-library - __Method__: POST - __Description__:  - __Summary__: Dodawanie dokumentu przez Handlowca - __RouteName__: POSTPrivateDocumentDetailsHandler - __Hash__: 74c24eb3027fc31b321f0fc2223c73cc - __Input__: SalesMailer\\Application\\Document\\CreateDocument - __Output__: SalesMailer\\Domain\\PrivateDocument - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: PrivateDocumentDetails - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createMyDocumentHandler(content?: CreateDocument, observe?: 'body', reportProgress?: boolean): Observable<PrivateDocumentDetails>;
    public createMyDocumentHandler(content?: CreateDocument, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrivateDocumentDetails>>;
    public createMyDocumentHandler(content?: CreateDocument, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrivateDocumentDetails>>;
    public createMyDocumentHandler(content?: CreateDocument, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PrivateDocumentDetails>(`${this.basePath}/api/my-library`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Usuwanie dokumentu przez Handlowca  (przestaje być dostępny, ale plik zostaje)
     *  - __InputModelName__: DeletePrivateDocument - __Path__: /my-library/{id} - __IsDeletableMethodName__: isDeletable - __TarEntity__:  - __EntityId__:  - __OperationName__: Handler - __OperationId__: DeleteMyDocumentHandler - __Name__:  - __Method__: DELETE - __Description__:  - __Summary__: Usuwanie dokumentu przez Handlowca  (przestaje być dostępny, ale plik zostaje) - __RouteName__: DELETEHandler - __Hash__: 61c1c1aa31a284d569bbf94ae00c9df6 - __Input__: SalesMailer\\Domain\\PrivateDocument - __Output__:  - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteMyDocumentHandler(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteMyDocumentHandler(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteMyDocumentHandler(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteMyDocumentHandler(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteMyDocumentHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/my-library/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista dokumentów wybranego handlowca
     *  - __Type__: doctrine - __PageSize__: 25 - __Entity__: SalesMailer\\Domain\\PrivateDocument - __OperationId__: MyDocumentListQuery - __OperationName__: ListQuery - __OutputModelName__: PrivateDocumentListItem - __ListModelName__: PrivateDocumentList - __DefaultSortOrder__:  - __Name__:  - __Path__: /my-library - __Method__: GET - __Description__:  - __Summary__: Lista dokumentów wybranego handlowca - __RouteName__: GETPrivateDocumentListItemListQuery - __Hash__: 482672dd36100a1c65a9dea8ad0ef4eb - __Input__:  - __Output__: SalesMailer\\Domain\\PrivateDocument - __InputGroups__:  - __OutputGroups__: list - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param page Numer strony (default: 1)
     * @param count Liczba wierszy na stronie (default: 25)
     * @param sortOrder Pole według którego nastąpi sortowanie
     * @param sortDirection Kierunek sortowania
     * @param isArchived  (boolean, exact)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public myDocumentListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe?: 'body', reportProgress?: boolean): Observable<PrivateDocumentList>;
    public myDocumentListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrivateDocumentList>>;
    public myDocumentListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrivateDocumentList>>;
    public myDocumentListQuery(page?: number, count?: number, sortOrder?: string, sortDirection?: 'ASC' | 'DESC', isArchived?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }
        if (sortOrder !== undefined && sortOrder !== null) {
            queryParameters = queryParameters.set('sortOrder', <any>sortOrder);
        }
        if (sortDirection !== undefined && sortDirection !== null) {
            queryParameters = queryParameters.set('sortDirection', <any>sortDirection);
        }
        if (isArchived !== undefined && isArchived !== null) {
            queryParameters = queryParameters.set('isArchived', <any>isArchived);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PrivateDocumentList>(`${this.basePath}/api/my-library`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     *  - __InputParser__: method - __UpdateMethodName__: archive - __Path__: /my-library/{id}/archive - __InputModelName__: UpdatePrivateDocument - __OperationName__: ArchiveMyDocumentHandler - __OperationId__: UpdatePrivateDocumentArchiveMyDocumentHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__:  - __RouteName__: PUTPrivateDocumentDetailsArchiveMyDocumentHandler - __Hash__: b4be69427b19a1871a5d6b7d95ba9e46 - __Input__: SalesMailer\\Domain\\PrivateDocument - __Output__: SalesMailer\\Domain\\PrivateDocument - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: PrivateDocumentDetails - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePrivateDocumentArchiveMyDocumentHandler(id: string, observe?: 'body', reportProgress?: boolean): Observable<PrivateDocumentDetails>;
    public updatePrivateDocumentArchiveMyDocumentHandler(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrivateDocumentDetails>>;
    public updatePrivateDocumentArchiveMyDocumentHandler(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrivateDocumentDetails>>;
    public updatePrivateDocumentArchiveMyDocumentHandler(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updatePrivateDocumentArchiveMyDocumentHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<PrivateDocumentDetails>(`${this.basePath}/api/my-library/${encodeURIComponent(String(id))}/archive`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     *  - __InputParser__: method - __UpdateMethodName__: unArchive - __Path__: /my-library/{id}/unarchive - __InputModelName__: UpdatePrivateDocument - __OperationName__: UnArchiveMyDocumentHandler - __OperationId__: UpdatePrivateDocumentUnArchiveMyDocumentHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__:  - __RouteName__: PUTPrivateDocumentDetailsUnArchiveMyDocumentHandler - __Hash__: fc28e90c3593ee172488dee0ba63e046 - __Input__: SalesMailer\\Domain\\PrivateDocument - __Output__: SalesMailer\\Domain\\PrivateDocument - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: PrivateDocumentDetails - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePrivateDocumentUnArchiveMyDocumentHandler(id: string, observe?: 'body', reportProgress?: boolean): Observable<PrivateDocumentDetails>;
    public updatePrivateDocumentUnArchiveMyDocumentHandler(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PrivateDocumentDetails>>;
    public updatePrivateDocumentUnArchiveMyDocumentHandler(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PrivateDocumentDetails>>;
    public updatePrivateDocumentUnArchiveMyDocumentHandler(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updatePrivateDocumentUnArchiveMyDocumentHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<PrivateDocumentDetails>(`${this.basePath}/api/my-library/${encodeURIComponent(String(id))}/unarchive`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
